import AppModal from '@components/AppModal';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        NickNameChangeModal: {};
    }
}

const NickNameChangeModal: ActivityComponentType<'NickNameChangeModal'> = () => {
    const { t } = useTranslation('accountSetting');
    const { pop } = useFlow();
    return (
        <AppModal title={t('nicknameModal.success')}
            confirm={t('nicknameModal.confirm')}
            onConfirm={pop} />
    );
};

export default NickNameChangeModal;
